export default __webpack_public_path__ + "static/media/LAS0920.34I-41362_-24658_0.6167f002.jpg";